import React, { useEffect, useState } from 'react';
import { fetchAuthSession } from 'aws-amplify/auth';

const BASE = "https://ltwph7gpvb.execute-api.us-east-1.amazonaws.com";
const MONTHS = ["January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"];

async function authHeaders() {
  const session = await fetchAuthSession();
  const token = session.tokens?.idToken?.toString();
  return { Authorization: `Bearer ${token}`, "Content-Type": "application/json" };
}

export default function WeatherRisk() {
  const [ports, setPorts] = useState([]);
  const [origin, setOrigin] = useState("Fujairah");
  const [destination, setDestination] = useState("Rotterdam");
  const [month, setMonth] = useState(new Date().getMonth() + 1);
  const [result, setResult] = useState(null);
  const [error, setError] = useState("");
  const [busy, setBusy] = useState(false);

  useEffect(() => {
    (async () => {
      try {
        const res = await fetch(`${BASE}/ports`, { headers: await authHeaders() });
        const data = await res.json();
        setPorts(data.ports);
      } catch {
        setError("Could not load ports");
      }
    })();
  }, []);

  async function check() {
    setError("");
    setResult(null);
    setBusy(true);
    try {
      const res = await fetch(`${BASE}/route-risk`, {
        method: "POST",
        headers: await authHeaders(),
        body: JSON.stringify({ origin, destination, month })
      });
      const data = await res.json();
      if (!res.ok) throw new Error(data.message || `Error ${res.status}`);
      setResult(data);
    } catch (err) {
      setError(err.message);
    } finally {
      setBusy(false);
    }
  }

  const level = (s) => String(s).toLowerCase();

  return (
    <div>
      <div className="card">
        <h2>Route details</h2>
        <div className="form">
          <div>
            <label>Origin</label>
            <select value={origin} onChange={(e) => setOrigin(e.target.value)}>
              {ports.map((p) => <option key={p}>{p}</option>)}
            </select>
          </div>
          <div>
            <label>Destination</label>
            <select value={destination} onChange={(e) => setDestination(e.target.value)}>
              {ports.map((p) => <option key={p}>{p}</option>)}
            </select>
          </div>
          <div>
            <label>Sailing month</label>
            <select value={month} onChange={(e) => setMonth(Number(e.target.value))}>
              {MONTHS.map((m, i) => <option key={m} value={i + 1}>{m}</option>)}
            </select>
          </div>
        </div>
        <button className="btn" onClick={check} disabled={busy}>
          {busy ? "Checking..." : "Check route"}
        </button>
        {error && <div className="err">{error}</div>}
      </div>

      {result && (
        <>
          <div className="card">
            <h2>Route risk rating</h2>
            <div className="score">
              {result.rating} <span className={`badge ${level(result.rating)}`}>{result.origin} → {result.destination}</span>
            </div>
            {result.routeNotes.map((n, i) => <p key={i} className="note">{n}</p>)}
          </div>

          <div className="card">
            <h2>Warnings</h2>
            {result.warnings.length === 0 && <p className="note">No major warnings for this route and month.</p>}
            {result.warnings.map((w, i) => (
              <div key={i} className={`alert ${level(w.severity)}`}>
                <b>{w.name}</b> <span className={`badge ${level(w.severity)}`}>{w.severity}</span>
                <p style={{ margin: "6px 0 2px" }}>{w.note}</p>
                <p className="note" style={{ margin: 0 }}>{w.advice}</p>
              </div>
            ))}
            {result.alternative && (
              <div className="alert">
                <b>{result.alternative.name}</b>
                <p style={{ margin: "6px 0 0" }}>{result.alternative.note}</p>
              </div>
            )}
          </div>

          <div className="card">
            <h2>7-day wave forecast at the ports</h2>
            <div className="metrics">
              {result.forecast.map((f) => (
                <div key={f.port} className="metric">
                  <span>{f.port}</span>
                  {f.maxWaveM !== undefined
                    ? <b>{f.maxWaveM} m max <span className={`badge ${level(f.level)}`}>{f.level}</span></b>
                    : <b style={{ fontSize: 14 }}>{f.status}</b>}
                </div>
              ))}
            </div>
            <p className="note">{result.note}</p>
          </div>
        </>
      )}
    </div>
  );
}